module.exports = __webpack_public_path__ + "img/front_17.90ed4601.svg";